import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryEquips = async (params: object) => {
  return await GET({ url: Api.queryEquips, params, showError: false })
}
